import { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { updateClipboard } from 'utils/clipboard';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.half};
  & > *:first-child {
    width: ${spacing.x24};
  }
`;

type CopyableInputFieldProps = {
  labelText: string;
  name: string;
  value: string;
};

export const CopyableInputField = ({ labelText, name, value }: CopyableInputFieldProps) => {
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();

  const copy = () => {
    updateClipboard(value)
      .then(() => {
        setCopied(true);
        dispatch(addPositiveToast(`${labelText} copied to the clipboard.`));
      })
      .catch(() => {
        dispatch(addNegativeToast(`Unable to copy ${labelText} to clipboard.`));
      });
  };

  const inputId = `${name}-input`;

  return (
    <FormField inputId={inputId} labelText={labelText}>
      <Row>
        <InputText id={inputId} name={name} isDisabled value={value} />
        <PrimaryButton onClick={copy} size={BUTTON_SIZES.LARGE}>
          {copied ? 'Copied!' : 'Copy'}
        </PrimaryButton>
      </Row>
    </FormField>
  );
};
